import { TextSearch, User } from "lucide-react";

import { SuperAdminOnly } from "@/components/shared/miscellaneous/superadmin-only";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

export enum OcrReviewModes {
  USER = "user",
  OCR_REVIEW = "ocr-review",
}

interface Props {
  reviewMode: OcrReviewModes;
  setReviewMode: (reviewMode: OcrReviewModes) => void;
  refetch: () => void;
}

export const OcrReviewMode = ({
  reviewMode,
  setReviewMode,
  refetch,
}: Props) => {
  const handleReviewModeChange = (reviewMode: OcrReviewModes) => {
    setReviewMode(reviewMode);
    refetch();
  };

  return (
    <SuperAdminOnly>
      <ToggleGroup
        type="single"
        value={reviewMode}
        onValueChange={handleReviewModeChange}
      >
        <ToggleGroupItem value={OcrReviewModes.USER} aria-label="Toggle user">
          <User className="h-4 w-4" />
        </ToggleGroupItem>
        <ToggleGroupItem
          value={OcrReviewModes.OCR_REVIEW}
          aria-label="Toggle ocr review"
        >
          <TextSearch className="h-4 w-4" />
        </ToggleGroupItem>
      </ToggleGroup>
    </SuperAdminOnly>
  );
};
